import {  Col, Divider, Dropdown, Menu, Row } from 'antd'
import { CaretDownOutlined } from '@ant-design/icons';
import { Bar } from 'react-chartjs-2';
import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie';
import api from '../utils/apiRoutes';
import GlobalLoading from '../Containers/GlobalLoading';

function PatientsBar() {

  const [bar_data, set_bar_data] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const headers = { 'Authorization': `Bearer ${Cookies.get('token_medical_auth')}` }
    setLoading(true);

    api.patientsBar.getPatientsBar({}, headers).then(res => {
      set_bar_data((res || []));
      // console.log(res, "HERE in patients bar");
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    })

  }, [])

    const options = {
        plugins: {
            title: {
                display: false,
           },
            legend: {
                display: false
            },
        },
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: true,
                    borderDash: [3, 2]
                  }
            },
            y: {
                stacked: true,
                grid: {
                    display: true,
                    borderDash: [3, 2]
                  }
            },
        },
    };


    const labels = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC'
    ];

    const data = {
      labels,
      datasets: [
        {
          label: 'Claim Amount',
          data: bar_data.monthsTotalArray,
          backgroundColor: '#B8D5E9',
          stack: 'Stack 0',
          barThickness: 10
        },
        {
          label: 'Approved Amount',
          data: bar_data.monthsSavedArray,
          backgroundColor: '#627FB5',
          stack: 'Stack 1',
          barThickness: 10
        }
      ],
    };

    if(loading) return <GlobalLoading />

  return (
    <div className="claim-amount-container patients-bar-container">
        {/* <h5>Amount</h5> */}
        <div className="claim-amount-box" style={{boxShadow:'none', border:'1px solid #C9C9C9'}}>
            <Row>
                <Col className="indicators" span={16}>
                    <div className="indicators-container" style={{fontSize:'16px', fontWeight:'500', marginRight:'1.25rem'}}>
                        <i className="color light-blue" style={{marginRight:'0.5rem'}}/>
                        Total Claim Amount
                    </div>
                    <div className="indicators-container" style={{fontSize:'16px', fontWeight:'500'}}>
                        <i className="color dark-blue" style={{marginRight:'0.5rem'}}/>
                        Amount Approved
                    </div>
                </Col>
                {/* <Col className="drop-btns-container" span={8}>
                    <Row>
                        <Col span={24}>
                            <Dropdown overlay={menu} placement="bottom">
                                <Button style={{ marginLeft: "auto", display: "block", marginRight: "42px", width: "30%" }}>Yearly <CaretDownOutlined /></Button>
                            </Dropdown>
                        </Col>
                    </Row>
                </Col> */}
            </Row>
            <Divider style={{margin:'1rem 0'}} />
            <Bar className="stats-donut" options={options} data={data}/>
        </div>
    </div>
  )
}

export default PatientsBar